import disclaimerObject_fr_BE from './touchpoints/disclaimerObject_fr_BE';
import disclaimerObject_nl_BE from './touchpoints/disclaimerObject_nl_BE';
import disclaimerObject_nl_NL from './touchpoints/disclaimerObject_nl_NL';

const classes = {
    disclaimerObject_fr_BE: disclaimerObject_fr_BE,
    disclaimerObject_nl_BE: disclaimerObject_nl_BE,
    disclaimerObject_nl_NL: disclaimerObject_nl_NL
};

export class disclaimerProxy {

    constructor (className) {
        // eslint-disable-next-line
        return (new classes[className]);
    }
}
